<template>
  <div id="all">
    <div class="view">
      <img src="../../../static/imgs/bg_light.png" alt="" />
      <div class="hover">
        <img
          v-if="navIndex == 1"
          src="../../../static/imgs/sc_light.png"
          alt=""
        />
        <img
          v-if="navIndex == 6"
          src="../../../static/imgs/sd_light.png"
          alt=""
        />
        <img
          v-if="navIndex == 3"
          src="../../../static/imgs/sx_light.png"
          alt=""
        />
        <img
          v-if="navIndex == 2"
          src="../../../static/imgs/shanx_light.png"
          alt=""
        />
        <img
          v-if="navIndex == 4"
          src="../../../static/imgs/hebei_light.png"
          alt=""
        />
        <img
          v-if="navIndex == 5"
          src="../../../static/imgs/henan_light.png"
          alt=""
        />
      </div>
      <!--      <div class="map_addr" v-for="(item,index) in menu" :key="index" :style="{'left':item.left,'top':item.top}">-->
      <!--        <div class="circle">-->
      <!--          <div class="label">-->
      <!--            <div class="province">-->
      <!--              <span>{{item.province}}</span>-->
      <!--              <div class="arrow"></div>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        <div class="contain_urls">-->
      <!--          <a :href="plat.url" target="_blank" v-for="(plat , index) in item.plat" :key="index">{{plat.name}}</a>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
// import menu from '../../js/menuInfo'
import niceScroll from "jquery.nicescroll";
export default {
  name: "all",
  data() {
    return {
      flag: {
        active: 0,
        actived: true,
        showMenu: true
      },
      // menu,
      v_niceScroll: null
    };
  },
  computed: {
    upImg() {},
    navIndex() {
      return this.$store.state.activeNav;
    }
  },
  methods: {
    toggleMenu(ev, index) {
      let vthis = this;
      this.flag.active = index;
      let $ele = $(ev.currentTarget);
      $(".plat")
        .stop()
        .slideUp(300);
      $ele
        .find(".plat")
        .stop()
        .slideToggle(300);
      $ele.toggleClass("active");
      $ele.hasClass("active")
        ? (this.flag.actived = true)
        : (this.flag.actived = false);
      this.$nextTick(function() {
        vthis.v_niceScroll.resize();
      });
    },
    isShowMenu(flag) {
      this.flag.showMenu = !this.flag.showMenu;
      if (flag) {
        $(".contain_menu_control").animate({ left: "320px" }, 300);
        $(".menu").animate({ flexBasis: "300px" }, 300);
      } else {
        $(".menu").animate({ flexBasis: "0px" }, 300);
        $(".contain_menu_control").animate({ left: "20px" }, 300);
        $(".menu").animate({ width: "300px" }, 300);
      }
    }
  },
  mounted() {
    this.v_niceScroll = $(".menu").niceScroll({
      cursoropacitymin: 0,
      cursoropacitymax: 0
    });
  }
};
</script>

<style scoped>
.maintain {
  pointer-events: none;
}

#all {
  position: relative;
  width: 100%;
  display: flex;
  height: 100%;
  flex-direction: row;
}

.view {
  flex: 1 1 auto;
  position: relative;
}

.view img {
  height: 100%;
  width: 100%;
  position: absolute;
  display: block;
}

.province {
  margin-bottom: 10px;
  background: #2d3e50;
  height: 70px;
  box-shadow: 0px 3px black;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.province .name {
  color: #2973a5;
  font-weight: bold;
  font-size: 18px;
  margin-left: 20px;
}

.province i {
  margin-right: 20px;
}

.menu-every .plat a {
  height: 45px;
  line-height: 45px;
  display: block;
  color: #2978ad;
  text-indent: 20px;
  font-size: 14px;
}

.menu-every .plat a:hover {
  background: #0e0e10;
}

.map_addr {
  position: absolute;
  z-index: 2;
  display: flex;
  justify-content: center;
}

.map_addr:hover {
  z-index: 3;
}

.map_addr:hover .contain_urls {
  display: block;
}

.circle {
  height: 12px;
  width: 12px;
  border-radius: 50%;
  background: #2d3e50;
  cursor: pointer;
}

.label {
  position: absolute;
  width: 80px;
  position: absolute;
  top: -45px;
  left: -35px;
}

.label .province {
  height: 30px;
  color: white;
  display: flex;
  justify-content: center;
  text-align: center;
  box-shadow: none;
  font-size: 12px;
  text-align: center;
}

.label .province .arrow {
  height: 0px;
  width: 0px;
  position: absolute;
  bottom: -6px;
  border: 8px solid;
  border-color: #2d3e50 transparent transparent transparent;
  left: calc(50% - 6px);
}

.contain_urls {
  position: absolute;
  padding: 10px;
  background: #374555;
  display: none;
  top: 12px;
  left: -50%;
}

.contain_urls a {
  color: #dedede;
  font-size: 12px;
  display: block;
  margin: 5px 0;
  text-align: center;
  white-space: nowrap;
}

.contain_urls a:hover {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/all/all.vue